import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconPlay from 'components/icons/IconPlay';

const VideoPlayIconWrapper = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      '[background:none] border-0 items-center justify-start bottom-0 top-20 flex flex-col left-0 absolute right-0 z-[1]',
      'hover:cursor-pointer',
      '[&_svg]:min-w-[70px] [&_svg]:w-[50px] [&_svg]:h-[50px]"'
    )}
  >
    <IconPlay width="14%" />
  </button>
);

VideoPlayIconWrapper.propTypes = {
  onClick: PropTypes.func,
};

export default VideoPlayIconWrapper;
